export enum ProductTypeEnum {
  DOMAINS = 'domains',
  SITE = 'site',
}
export enum partnerNavigationActionType {
  GetStarted = 'get-started',
  Upgrade = 'upgrade',
  UpgradePlan = 'upgrade-plan',
  BillingCyclePage = 'select-billing-cycle',
  BillingCycleInternalPage = 'select-billing-cycle-internal',
  GetDomains = 'get-domains',
  PurchaseDomain = 'purchase-domain',
  ConnectDomain = 'connect-domain',
  TransferDomain = 'transfer-domain',
  HowToConnectDomain = 'connect-domain-help',
  DomainWixRegistration = 'domain-wix-registration',
  ReviewAndBuyDomain = 'review-and-buy',
  ConnectDomainBuildWebsite = 'connect-domain-build-website',
}
export type partnerNavigationActionProperties = {
  value: string;
  productType: string;
};

export const GetStarted: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.GetStarted,
  productType: ProductTypeEnum.SITE,
};

export const Upgrade: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.Upgrade,
  productType: ProductTypeEnum.SITE,
};
export const UpgradePlan: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.UpgradePlan,
  productType: ProductTypeEnum.SITE,
};
export const BillingCyclePage: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.BillingCyclePage,
  productType: ProductTypeEnum.SITE,
};
export const BillingCycleInternalPage: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.BillingCycleInternalPage,
  productType: ProductTypeEnum.SITE,
};
export const GetDomains: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.GetDomains,
  productType: ProductTypeEnum.DOMAINS,
};
export const PurchaseDomain: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.PurchaseDomain,
  productType: ProductTypeEnum.DOMAINS,
};
export const ConnectDomain: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.ConnectDomain,
  productType: ProductTypeEnum.DOMAINS,
};
export const TransferDomain: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.TransferDomain,
  productType: ProductTypeEnum.DOMAINS,
};
export const HowToConnectDomain: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.HowToConnectDomain,
  productType: ProductTypeEnum.DOMAINS,
};
export const DomainWixRegistration: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.DomainWixRegistration,
  productType: ProductTypeEnum.DOMAINS,
};
export const ReviewAndBuyDomain: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.ReviewAndBuyDomain,
  productType: ProductTypeEnum.DOMAINS,
};
export const ConnectDomainBuildWebsite: partnerNavigationActionProperties = {
  value: partnerNavigationActionType.ConnectDomainBuildWebsite,
  productType: ProductTypeEnum.DOMAINS,
};
